import React from 'react';
import { NewsArticle } from '../../types';
import { Link } from 'react-router-dom';

interface NewsCardProps {
  article: NewsArticle;
}

const NewsCard: React.FC<NewsCardProps> = ({ article }) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  return (
    <div className="bg-white overflow-hidden shadow rounded-lg h-full flex flex-col">
      <div className="p-6 flex-1 flex flex-col">
        <div className="flex items-center mb-2">
          {article.source && (
            <span className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-blue-100 text-blue-800 mr-2">
              {article.source.name}
            </span>
          )}
          {article.topic && (
            <span className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-green-100 text-green-800">
              {article.topic.name}
            </span>
          )}
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2 line-clamp-2 flex-none">
          <Link to={`/news/${article.id}`} className="hover:text-primary-600">
            {article.title}
          </Link>
        </h3>
        <p className="mt-2 text-sm text-gray-500 line-clamp-4 flex-1">
          {article.content}
        </p>
        <div className="mt-4 flex items-center justify-between flex-none">
          <div className="text-sm text-gray-500">
            {formatDate(article.published_at)}
          </div>
          <Link
            to={`/news/${article.id}`}
            className="inline-flex items-center px-3 py-1 border border-transparent text-sm font-medium rounded-md text-primary-700 bg-primary-100 hover:bg-primary-200"
          >
            阅读全文
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NewsCard;
